import React from 'react'
import { assignmentStatusOptions } from '@edulastic/constants'
import { themeColor, white } from '@edulastic/colors'
import { IconBarChart } from '@edulastic/icons'
import profileReportsPreviewImg from './assets/profile_report_joyride.svg'

export const TAB_KEYS = {
  ASSIGNMENTS: '1',
  MY_CLASSES: '2',
}

const statusToLowercase = {
  'IN PROGRESS': 'In Progress',
  'IN GRADING': 'In Grading',
  DONE: 'Done',
  'NOT OPEN': 'Not Open',
}

export const OPEN_ID_PROVIDERS = {
  CLI: 'cli',
}

export const LMS_ID_FIELDS = [
  'googleId',
  'atlasId',
  'cleverId',
  'msoId',
  'canvasId',
  'cliId',
  'newselaId',
  'rosterSourcedId',
]

export const getAssignmentStatus = (status, isPaused) => {
  return `${statusToLowercase[status]}${
    isPaused && status !== assignmentStatusOptions.DONE ? ' (Paused)' : ''
  }`
}
export const DASHBOARD_VERSION = {
  NEW_DASHBOARD: 1,
  OLD_DASHBOARD: 0,
}

export const isTestCreationLifecycleBannerDismissed = (userId) => {
  if (!userId) return false
  try {
    const stored =
      JSON.parse(localStorage.getItem('testCreationBannerClosedUserIds')) || []
    return Array.isArray(stored) && stored.includes(userId)
  } catch {
    return false
  }
}

const newDashboardOverviewTailSteps = [
  {
    target: '[data-joyride-id="classesTab"]',
    title: 'View your classes',
    content:
      'Manage your active classes and view related assignments and reports.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-joyride-id="gridListView"]',
    title: 'View class as grid or list',
    content:
      'Select the desired class view as grid or as list, based on your preference.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-joyride-id="assignmentTab"]',
    title: 'Access recent assignments',
    content:
      'View your recent assignments, check submission and grading status and associated reports.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-joyride-id="newTestBanner"]',
    title: 'Quick access to popular test categories',
    content:
      'Jump right into Test creation flow of your choice and start creating test.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-joyride-id="contentSearch"]',
    title: 'Unified content search',
    content:
      'Easily search test, items or assignment right from the dashboard.',
    placement: 'bottom',
    disableBeacon: true,
  },
]

export const newDashboardOverviewSteps = [
  {
    target: '[data-joyride-id="userLifecycleBanner"]',
    title: 'Get Started',
    content:
      'Quickly Create / Import your test  or assign a test from our library.',
    placement: 'bottom',
    disableBeacon: true,
  },
  ...newDashboardOverviewTailSteps,
]

export const newDashboardOverviewStepsWithoutLifecycleBanner = [
  ...newDashboardOverviewTailSteps,
]

export const DASHBOARD_VISIT_SEGMENT_EVENT = 'Dashboard visit'

export const PROFILE_REPORTS_JOYRIDE_PREVIEW_ALT =
  'Preview of Class Profile reports showing domain understanding and priority areas'

export const PROFILE_REPORTS_JOYRIDE_SEGMENT_CTA = 'ProfileReports'

export const PROFILE_REPORTS_JOYRIDE_TARGET =
  '[data-joyride-id="profileReports"]'

export const PROFILE_REPORTS_JOYRIDE_LAYOUT_STABLE_MS = 150
export const PROFILE_REPORTS_JOYRIDE_LAYOUT_MAX_WAIT_MS = 5000
export const PROFILE_REPORTS_JOYRIDE_START_DELAY_MS = 200

export const getProfileReportsJoyrideVisit1CompletedSessionKey = (userId) =>
  `profileReportsJoyrideVisit1Completed:${userId}`

export const markProfileReportsJoyrideVisit1CompletedThisSession = (userId) => {
  if (!userId) return
  sessionStorage.setItem(
    getProfileReportsJoyrideVisit1CompletedSessionKey(userId),
    'true'
  )
}

export const isProfileReportsJoyrideVisit1CompletedThisSession = (userId) =>
  Boolean(userId) &&
  sessionStorage.getItem(
    getProfileReportsJoyrideVisit1CompletedSessionKey(userId)
  ) === 'true'

const PROFILE_REPORTS_JOYRIDE_BODY =
  'See how your class and students are performing across domains and standards to identify strengths, learning gaps, and next steps.'

const ProfileReportsJoyrideTitle = ({ style }) => (
  <p
    style={{
      margin: '12px 0 8px',
      fontWeight: 700,
      fontSize: 14,
      ...style,
    }}
  >
    Introducing Class Reports
  </p>
)

const ProfileReportsJoyrideIcon = () => (
  <div
    style={{
      width: 48,
      height: 48,
      borderRadius: 8,
      backgroundColor: themeColor,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: 12,
    }}
  >
    <IconBarChart color={white} width={24} height={24} />
  </div>
)

export const profileReportsJoyrideStepsVisit1 = [
  {
    target: PROFILE_REPORTS_JOYRIDE_TARGET,
    title: '',
    content: (
      <>
        <img
          src={profileReportsPreviewImg}
          alt={PROFILE_REPORTS_JOYRIDE_PREVIEW_ALT}
          style={{ width: '100%', display: 'block', borderRadius: 8 }}
        />
        <ProfileReportsJoyrideTitle />
        <p style={{ margin: 0, fontSize: 14 }}>
          {PROFILE_REPORTS_JOYRIDE_BODY}
        </p>
      </>
    ),
    placement: 'right',
    disableBeacon: true,
  },
]

export const profileReportsJoyrideStepsVisit2 = [
  {
    target: PROFILE_REPORTS_JOYRIDE_TARGET,
    title: '',
    content: (
      <>
        <ProfileReportsJoyrideIcon />
        <ProfileReportsJoyrideTitle style={{ marginTop: 0 }} />
        <p style={{ margin: 0, fontSize: 14 }}>
          {PROFILE_REPORTS_JOYRIDE_BODY}
        </p>
      </>
    ),
    placement: 'right',
    disableBeacon: true,
  },
]
